/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { api, mutatingPost, type ApiResult } from "./client";

/** Mirror of nexus CoordinatorQueueEntry (camelCase wire format). */
export type QueueEntry = {
  id: string;
  agentRunId: string;
  agentOutreachId: string | null;
  patientId: string | null;
  providerId: string | null;
  freedSlotStartsAt: string | null;
  freedSlotEndsAt: string | null;
  suggestedAction: unknown;
  confidence: number | null;
  confidenceBreakdown: Record<string, number> | null;
  reasoning: string;
  status: "OPEN" | "CLAIMED" | "RESOLVED" | "EXPIRED";
  claimedByUserId: string | null;
  claimedAt: string | null;
  resolvedAt: string | null;
  resolutionNote: string | null;
  createdAt: string;
};

/** Mirror of nexus CoordinatorCase: the entry plus everything a human needs to act on it. */
export type CoordinatorCase = {
  entry: QueueEntry;
  patient: {
    firstName: string | null;
    lastName: string | null;
    phoneE164: string | null;
    payerId: string | null;
    memberId: string | null;
  };
  provider: { firstName: string | null; lastName: string | null } | null;
  waitlist: {
    services: string[];
    state: string | null;
    acuity: string | null;
    flexibility: string | null;
    primaryReason: string | null;
    preferredDays: string[];
  } | null;
  outreach: {
    rank: number;
    status: string | null;
    response: string | null;
    responseBody: string | null;
    responseAt: string | null;
    booked: boolean;
    bookedHealthieAppointmentId: string | null;
  } | null;
};

export function listOpen(limit = 50): Promise<ApiResult<CoordinatorCase[]>> {
  return api<CoordinatorCase[]>(`/v1/coordinator/queue?limit=${limit}`);
}

export function claim(id: string): Promise<ApiResult<QueueEntry>> {
  return api<QueueEntry>(`/v1/coordinator/queue/${id}/claim`, mutatingPost({}));
}

export function resolve(id: string, note: string): Promise<ApiResult<QueueEntry>> {
  return api<QueueEntry>(`/v1/coordinator/queue/${id}/resolve`, mutatingPost({ note }));
}
